<template>
    <div class="course-container" id="home-top">
        <!--详情-->
        <div class="topic-detail" v-if="showMode==='view'">
            <div class="topic-top" >
                <div class="topic-top-left">
                    <div class="top-left1">{{info.topicName}}</div>
                    <div class="top-left2">子课题申报&nbsp;&nbsp; {{ timestampToTime(info.applyBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.applyEndTime)}}</div>
                </div>
                <div class="topic-top-right">
                        <div class="top-right-item">
                            <!-- 未申报 -->
                            <div class="top-right1" v-if="isApply === 0"></div>
                            <div class="top-right1 btn-sbkt" v-if="this.info.isRelease===0&&isApply === 0&&currentTime>this.info.applyBeginTime&&currentTime<this.info.applyEndTime&&this.info.status===1" @click="applyTopic">子课题申报</div>
                            <!-- 已申报 -->
                            <div class="top-right1 btn-sbkt" v-if="this.info.isRelease===0&&isApply === 1&&this.info.status===1&&this.topicForm.isCheck!==3" @click="applyTopic">申报编辑</div>
                            <div class="top-right1 btn-sbkt" v-if="this.info.isRelease===0&&isApply === 1&&this.info.status===1&&this.topicForm.isCheck===3" @click="viewApplyTopic">查看资料</div>
                            <div class="top-right1 bg-dsh" v-if="this.info.isRelease===0&&isApply === 1&&this.info.status===1&&(this.topicForm.isCheck===1||this.topicForm.isCheck===2)">申报待审核</div>
                            <div class="top-right1 bg-ytg" v-if="this.info.isRelease===0&&isApply === 1&&this.info.status===1&&this.topicForm.isCheck===3">通过</div>
                            <el-tooltip
                              class="box-item"
                              effect="dark"
                              content="点击查看驳回原因"
                              placement="bottom">
                                <div class="top-right1 bg-wtg" v-if="isApply === 1&&this.topicForm.isCheck===4" @click="viewReason">驳回</div>
                            </el-tooltip>
                        </div>
                        <div class="top-right-item">
                             <div class="top-right1"></div>
                             <div class="top-right2 btn-cjkt" v-if="this.info.isRelease===0&&this.info.status===1&&(currentTime<this.info.checkBeginTime)" @click="joinSonTopic">参加子课题</div>
                        </div>
                </div>
            </div>
            <!--课题内容-->
            <div class="topic-info-container">
                <div class="topic-info-l-container">
                    <div class="topic-info-l-content">
                        <!--时间安排-->
                        <div class="topic-time-container">
                            <!--时间安排-->
                            <div class="topic-time-top">
                                <div class="topic-time-top1">
                                    <svg t="1747272742501" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6440" width="20" height="21"><path d="M896 1024h-768A128 128 0 0 1 0 896v-682.666667A128 128 0 0 1 128 85.333333H256V42.666667a42.666667 42.666667 0 0 1 85.333333 0V85.333333h341.333334V42.666667a42.666667 42.666667 0 0 1 85.333333 0V85.333333h128A128 128 0 0 1 1024 213.333333v682.666667a128 128 0 0 1-128 128zM85.333333 386.133333V896A42.666667 42.666667 0 0 0 128 938.666667h768a42.666667 42.666667 0 0 0 42.666667-42.666667V386.133333H85.333333z m0-85.333333h853.333334V213.333333A42.666667 42.666667 0 0 0 896 170.666667H768v42.666666a42.666667 42.666667 0 0 1-85.333333 0V170.666667H341.333333v42.666666a42.666667 42.666667 0 0 1-85.333333 0V170.666667H128A42.666667 42.666667 0 0 0 85.333333 213.333333v87.466667zM456.533333 808.106667a42.666667 42.666667 0 0 1-29.013333-11.52l-115.626667-108.8a42.865778 42.865778 0 0 1 58.88-62.293334l85.333334 80.64L652.8 512a42.666667 42.666667 0 0 1 59.733333 60.586667l-225.706666 222.72a42.666667 42.666667 0 0 1-30.293334 12.8z" fill="#0d55a4" p-id="6441"></path></svg>
                                </div>
                                <div class="topic-time-top2">
                                    课题时间安排
                                </div>
                            </div>
                            <div class="topic-time-content">
                                <div class="time-content-item">
                                    <div class="time-point"><div class="point"></div></div>
                                    <div class="time-item">
                                        <div class="time-title1">子课题申报</div>
                                        <div class="time-title2">{{ timestampToTime(info.applyBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.applyEndTime)}}</div>
                                    </div>
                                </div>
                                <div class="time-content-item">
                                    <div class="time-point"><div class="point"></div></div>
                                    <div class="time-item">
                                        <div class="time-title1">结题验收</div>
                                        <div class="time-title2">{{ timestampToTime(info.checkBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.checkEndTime)}}</div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <!--基础信息-->
                        <div class="topic-time-container">
                            <!--基础信息-->
                            <div class="topic-time-top">
                                <div class="topic-time-top1">
                                    <svg t="1745994994411" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10489" width="24" height="24"><path d="M210.823529 839.183059V120.470588H146.040471C114.672941 120.470588 90.352941 152.997647 90.352941 180.976941v787.681883C90.352941 987.030588 100.020706 1024 146.040471 1024h621.492705C782.351059 1024 813.176471 1008.941176 813.176471 968.643765V918.588235H290.590118C245.955765 918.588235 210.823529 872.779294 210.823529 839.183059zM786.808471 180.705882h160.015058L768 0v162.590118c0 12.182588 6.144 18.115765 18.808471 18.115764z" p-id="10490" fill="#0d55a4"></path><path d="M786.808471 195.764706C765.906824 195.764706 752.941176 183.055059 752.941176 162.590118V0H275.531294C246.287059 0 225.882353 21.443765 225.882353 51.772235L226.123294 120.470588H225.882353v718.712471C225.882353 865.249882 258.514824 903.529412 290.590118 903.529412H881.935059C912.384 903.529412 948.705882 868.201412 948.705882 839.183059V195.764706H786.808471zM813.176471 692.705882H378.157176c-5.270588 8.704-14.757647 14.592-25.690352 14.592a30.117647 30.117647 0 0 1 0-60.235294c11.309176 0 21.052235 6.309647 26.202352 15.525647H813.176471c8.282353 0 15.058824 6.776471 15.058823 15.058824s-6.776471 15.058824-15.058823 15.058823z m0-225.882353H378.157176c-5.270588 8.704-14.757647 14.592-25.690352 14.592a30.117647 30.117647 0 0 1 0-60.235294c11.309176 0 21.052235 6.309647 26.202352 15.525647H813.176471c8.282353 0 15.058824 6.776471 15.058823 15.058824s-6.776471 15.058824-15.058823 15.058823z m0-210.823529H378.157176c-5.270588 8.704-14.757647 14.592-25.690352 14.592a30.117647 30.117647 0 0 1 0-60.235294c11.309176 0 21.052235 6.309647 26.202352 15.525647H813.176471c8.282353 0 15.058824 6.776471 15.058823 15.058823s-6.776471 15.058824-15.058823 15.058824z" p-id="10491" fill="#0d55a4"></path></svg>
                                </div>
                                <div class="topic-time-top2">
                                    基础信息
                                </div>
                            </div>
                            <div class="topic-base-info-container">
                                <div class="base-one-container">
                                    <div class="base-one-info-80">课题名称：<span style="color: #767676">{{info.topicName}}</span></div>
                                </div>
                            </div>
                            <div class="topic-base-info-container">
                                <div class="base-one-container">
                                    <div class="base-one-info">
                                        <div >课题级别：<span style="color: #767676">{{info.topicLevelName}}</span></div>
                                    </div>
                                    <div class="base-one-info">课题方向：<span style="color: #767676">{{info.topicClassifyName}}</span></div>
                                </div>
                            </div>
                            <div class="topic-base-info-container">
                                <div class="base-one-container">
                                    <div class="base-one-info">课题单位：<span style="color: #767676">{{info.orgNames}}</span></div>
                                    <div class="base-one-info">课题负责人：<span style="color: #767676">{{info.leaderNames}}</span></div>
                                </div>
                            </div>
                            <div class="topic-base-info-container">
                                <div class="base-one-container">
                                    <div class="base-one-info">子课题量：<span style="color: #767676">{{info.topicCount}}</span></div>
                                    <div class="base-one-info">联系方式：<span style="color: #767676">{{info.contactInfo}}</span></div>
                                </div>
                            </div>
                        </div>
                        <!--课题介绍-->
                        <div class="topic-title-container" v-if="info.topicType===0&&info.recommend">
                            <div class="topic-title-container1">
                                <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#0d55a4" p-id="12410"></path></svg>
                            </div>
                            <div class="topic-title-container2">
                                课题介绍
                            </div>
                        </div>
                        <div class="topic-content-container" v-if="info.topicType===0&&info.recommend">
                            {{info.recommend}}
                        </div>
                        <div class="topic-title-container" v-if="info.topicType===1&&info.imgUrl">
                            <div class="topic-title-container1">
                                <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#0d55a4" p-id="12410"></path></svg>
                            </div>
                            <div class="topic-title-container2">
                                课题内容
                            </div>
                        </div>
                        <div class="topic-content-container-img" v-if="info.topicType===1&&info.imgUrl">
                            <el-image style="width: 200px; height: 320px;cursor: pointer"
                                      :src="info.imgUrl"
                                      :preview-teleported="true"
                                      :preview-src-list="[info.imgUrl]"
                                      :initial-index="1"
                                      fit="fill" />
                        </div>


                        <div class="topic-title-container" v-if="info.topicType===0&&info.studyAim">
                            <div class="topic-title-container1">
                            </div>
                            <div class="topic-title-container2">
                                研究目的
                            </div>
                        </div>
                        <div class="topic-content-container" v-if="info.topicType===0&&info.studyAim">
                            {{info.studyAim}}
                        </div>

                        <div class="topic-title-container" v-if="info.topicType===0&&info.studyMethod">
                            <div class="topic-title-container1">
                            </div>
                            <div class="topic-title-container2">
                                研究方法
                            </div>
                        </div>
                        <div class="topic-content-container" v-if="info.topicType===0&&info.studyMethod">
                            {{info.studyMethod}}
                        </div>

                        <div class="topic-title-container" v-if="info.remarks">
                            <div class="topic-title-container1">
                                <svg t="1746002797480" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16363" width="24" height="24"><path d="M512 1024a512 512 0 1 1 512-512 512 512 0 0 1-512 512z m0-819.2a51.2 51.2 0 1 0 51.2 51.2 51.2 51.2 0 0 0-51.2-51.2z m51.2 256a51.2 51.2 0 0 0-102.4 0v307.2a51.2 51.2 0 0 0 102.4 0V460.8z" fill="#0d55a4" p-id="16364"></path></svg>
                            </div>
                            <div class="topic-title-container2">
                                其他说明
                            </div>
                        </div>
                        <div class="topic-content-container" v-if="info.remarks">
                            {{info.remarks}}
                        </div>

                        <div class="topic-title-container" v-if="info.fileList&&info.fileList.length>0">
                            <div class="topic-title-container1">
                                <svg t="1746001513851" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15262" width="24" height="24"><path d="M512 0a512 512 0 1 0 512 512A512 512 0 0 0 512 0z m128 502.613A128 128 0 0 1 502.613 640l-216.746 98.133L384 521.387A128 128 0 0 1 521.387 384l216.746-98.133z" fill="#0d55a4" p-id="15263"></path></svg>
                            </div>
                            <div class="topic-title-container2">
                                课题附件
                            </div>
                        </div>
                        <div class="file-list">
                            <div class="file-item" v-for="item in info.fileList" :key="item">
                                <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                <div class="file-view">
                                    <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                              :src="require('@/assets/file/file_view_color.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                    </el-image>
                                </div>
                                <div class="file-view" @click="downloadFile(item)">
                                    <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                </div>
                            </div>
                        </div>

                        <!--立项与基础材料-->
                        <div class="topic-title-container" v-if="info.isRelease===1&&info.status===2">
                            <div class="topic-title-container1">
                                <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#0d55a4" p-id="12410"></path></svg>
                            </div>
                            <div class="topic-title-container2">
                                立项与基础材料
                            </div>
                        </div>
                        <div class="topic-file-container-second" v-if="info.isRelease===1&&info.status===2">
                            <div class="topic-file-item-title">
                                立项申报书
                            </div>
                            <div class="file-list">
                                <div class="file-item-second" v-for="item in releaseInfo.sbsFileList" :key="item">
                                    <div class="file-title">{{item.fileName}}</div>
                                    <div class="file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                    </div>
                                </div>
                                <div class="div-100"  v-if="releaseInfo.sbsFileList&&releaseInfo.sbsFileList.length===0">
                                    <dataEmpty :is-img="false" title="暂无此类文件" />
                                </div>
                            </div>
                        </div>
                        <div class="topic-file-container-second" v-if="info.isRelease===1&&info.status===2">
                            <div class="topic-file-item-title">
                                <span style="color: red">*</span>立项通知书
                            </div>
                            <div class="file-list">
                                <div class="file-item-second" v-for="item in releaseInfo.tzsFileList" :key="item">
                                    <div class="file-title">{{item.fileName}}</div>
                                    <div class="file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                    </div>
                                </div>
                                <div class="div-100"  v-if="releaseInfo.tzsFileList&&releaseInfo.tzsFileList.length===0">
                                    <dataEmpty :is-img="false" title="暂无此类文件" />
                                </div>
                            </div>
                        </div>

                        <!--开题报告-->
                        <div class="topic-title-container" v-if="info.isRelease===1&&info.status===2">
                            <div class="topic-title-container1">
                                <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#0d55a4" p-id="12410"></path></svg>
                            </div>
                            <div class="topic-title-container2">
                                开题报告
                            </div>
                        </div>
                        <div class="file-list" v-if="info.isRelease===1&&info.status===2">
                            <div class="file-item" v-for="item in releaseInfo.ktbgFileList" :key="item">
                                <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                <div class="file-view">
                                    <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                              :src="require('@/assets/file/file_view_color.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                    </el-image>
                                </div>
                                <div class="file-view" @click="downloadFile(item)">
                                    <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                </div>
                            </div>
                        </div>

                        <!--成果类材料-->
                        <div class="topic-title-container" v-if="info.isRelease===1&&info.status===2">
                            <div class="topic-title-container1">
                                <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#0d55a4" p-id="12410"></path></svg>
                            </div>
                            <div class="topic-title-container2">
                                成果类材料
                            </div>
                        </div>

                        <div class="topic-sign-title-second" v-if="info.isRelease===1&&info.status===2">
                            核心报告类材料
                        </div>
                        <div class="topic-file-container-second" v-if="info.isRelease===1&&info.status===2">
                            <div class="topic-file-item-title">
                                <span style="color: red">*</span>结题报告
                            </div>
                            <div class="file-list">
                                <div class="file-item-second" v-for="item in releaseInfo.jtbgFileList" :key="item">
                                    <div class="file-title">{{item.fileName}}</div>
                                    <div class="file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                    </div>
                                </div>
                                <div class="div-100"  v-if="releaseInfo.jtbgFileList&&releaseInfo.jtbgFileList.length===0">
                                    <dataEmpty :is-img="false" title="暂无此类文件" />
                                </div>
                            </div>
                        </div>

                        <div class="topic-file-container-second" v-if="info.isRelease===1&&info.status===2">
                            <div class="topic-file-item-title">
                                工作报告
                            </div>
                            <div class="file-list">
                                <div class="file-item-second" v-for="item in releaseInfo.gzbgFileList" :key="item">
                                    <div class="file-title">{{item.fileName}}</div>
                                    <div class="file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                    </div>
                                </div>
                                <div class="div-100" v-if="releaseInfo.gzbgFileList&&releaseInfo.gzbgFileList.length===0">
                                    <dataEmpty :is-img="false" title="暂无此类文件" />
                                </div>
                            </div>
                        </div>

                        <div class="topic-sign-title-second" v-if="info.isRelease===1&&info.status===2">
                            成果类材料
                        </div>
                        <div class="topic-file-container-second" v-if="info.isRelease===1&&info.status===2">
                            <div class="topic-file-item-title">
                                论文与著作
                            </div>
                            <div class="file-list">
                                <div class="file-item-second" v-for="item in releaseInfo.lwzzFileList" :key="item">
                                    <div class="file-title">{{item.fileName}}</div>
                                    <div class="file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                    </div>
                                </div>
                                <div class="div-100" v-if="releaseInfo.lwzzFileList&&releaseInfo.lwzzFileList.length===0">
                                    <dataEmpty :is-img="false" title="暂无此类文件" />
                                </div>
                            </div>
                        </div>

                        <div class="topic-file-container-second" v-if="info.isRelease===1&&info.status===2">
                            <div class="topic-file-item-title">
                                <span style="color: red">*</span>教学案例与课件
                            </div>
                            <div class="file-list">
                                <div class="file-item-second" v-for="item in releaseInfo.alkjFileList" :key="item">
                                    <div class="file-title">{{item.fileName}}</div>
                                    <div class="file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                    </div>
                                </div>
                                <div class="div-100" v-if="releaseInfo.alkjFileList&&releaseInfo.alkjFileList.length===0">
                                    <dataEmpty :is-img="false"  title="暂无此类文件" />
                                </div>
                            </div>
                        </div>

                        <div class="topic-file-container-second" v-if="info.isRelease===1&&info.status===2">
                            <div class="topic-file-item-title">
                                获奖证书
                            </div>
                            <div class="file-list">
                                <div class="file-item-second" v-for="item in releaseInfo.hjzsFileList" :key="item">
                                    <div class="file-title">{{item.fileName}}</div>
                                    <div class="file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                    </div>
                                </div>
                                <div class="div-100" v-if="releaseInfo.hjzsFileList&&releaseInfo.hjzsFileList.length===0">
                                    <dataEmpty :is-img="false" title="暂无此类文件" />
                                </div>
                            </div>
                        </div>


                        <div class="topic-sign-title-second" v-if="info.isRelease===1&&info.status===2">
                            附件
                        </div>
                        <div class="topic-file-container-second" v-if="info.isRelease===1&&info.status===2">
                            <div class="topic-file-item-title">
                                附件
                            </div>
                            <div class="file-list">
                                <div class="file-item-second" v-for="item in releaseInfo.fbfjFileList" :key="item">
                                    <div class="file-title">{{item.fileName}}</div>
                                    <div class="file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                    </div>
                                </div>
                                <div class="div-100" v-if="releaseInfo.fbfjFileList&&releaseInfo.fbfjFileList.length===0">
                                    <dataEmpty :is-img="false" title="暂无此类文件" />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <!--统计图-->
                <div class="topic-info-r-container">
                    <div class="topic-data-title">子课题申报统计</div>
                    <div>
                        <child-topic-pie-echarts
                            :dfp-count="this.info.dfpCount"
                            :dsh-count="this.info.dshCount"
                            :shtg-count="this.info.shtgCount"
                        />
                    </div>
                </div>
            </div>
            <!--子课题列表-->
            <div class="info-list-container" id="sonTopic">
                <el-row class="mt10 ml10 mb8" v-if="info.status===1">
                    <el-col :span="5" class="mb0">
                        <el-form-item label="子课题状态">
                            <el-select clearable @change="filterSonTopic" v-model="queryParams.status" placeholder="请选择">
                                <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                                           :value="item.value" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" class="mb0">
                        <el-form-item label="是否参与" label-width="80px" label-position="right">
                            <el-select clearable @change="filterSonTopic" v-model="queryParams.isApply" placeholder="请选择">
                                <el-option v-for="item in joinList" :key="item.value" :label="item.name"
                                           :value="item.value" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="course-list-box">
                    <div class="course-item" v-for="item in topicList" :key="item">
                        <el-card :body-style="{ padding: '0px' }" class="course-one" @click="joinTopic(item.topicId)">
                            <div class="course-name">{{item.topicName}}</div>
                            <div class="course-info">
                                <div class="course-cover">
                                    <img class="img-100"  :src="'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/szpx.png'" alt />
                                </div>
                                <div class="course-title">
                                    <div class="course-subject">
                                        <div class="status-info-bm" v-if="item.status===1">报名阶段</div>
                                        <div class="status-info-kt" v-if="item.status===2">开题阶段</div>
                                        <div class="status-info-zq" v-if="item.status===3">中期检查</div>
                                        <div class="status-info-jt" v-if="item.status===4">结题验收</div>
                                        <div class="status-info-js" v-if="item.status===5">课题结束</div>

                                        <div class="status-info-wcy" v-if="item.isApply===0">未参与</div>
                                        <div class="status-info-ycy" v-if="item.isApply===1">已参与</div>
                                    </div>
                                    <div class="course-team-user">课题方向：{{info.topicClassifyName}}</div>
                                    <div class="course-team-user">课题负责人：{{item.sonLeaderNames}}</div>
                                    <div class="course-team-user">课题单位：{{item.orgName}}</div>
                                    <div class="course-team-user">学段学科：{{item.periodName}}、{{item.subjectName}}</div>

                                </div>
                            </div>
                        </el-card>
                    </div>
                </div>
                <data-empty v-if="topicList&&topicList.length===0" title="暂无子课题"/>
            </div>

            <div class="back-btn-container">
                <div class="back-btn" @click="changeModel">返回</div>
            </div>
        </div>
        <!--子课题申报-->
        <div class="topic-detail" v-if="showMode==='apply'">
            <div class="topic-sign-container">
                <div class="topic-sign-title">子课题申报</div>
                <div class="topic-sign-name">
                    {{info.topicName}}
                </div>
                <div class="topic-sign-form">
                    <el-form ref="topicForm" :model="topicForm"
                             :rules="topicFormRules" label-width="100px">
                        <div class="topic-title-container">
                            <div class="topic-title-container1">
                                <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#0d55a4" p-id="12410"></path></svg>
                            </div>
                            <div class="topic-title-container2">
                                基本信息
                            </div>
                        </div>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="教师姓名" prop="trueName">
                                    <el-input disabled v-model="topicForm.trueName" placeholder="请输入教师姓名"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item label="所属学校" prop="trueName">
                                    <el-input disabled v-model="topicForm.orgName" placeholder="请输入所属学校"  />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="任教学段" prop="periodKey">
                                    <el-select @change="changePeriod" style="width: 100%;" v-model="topicForm.periodKey"
                                               placeholder="请选择任教学段">
                                        <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item label="任教学科" prop="subjectKey">
                                    <el-select style="width: 100%;" v-model="topicForm.subjectKey"
                                               placeholder="请选择任教学科">
                                        <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="最高学历" prop="qualificationKey">
                                    <el-select style="width: 100%;" v-model="topicForm.qualificationKey"
                                               placeholder="请选择最高学历">
                                        <el-option v-for="item in qualificationList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item label="技术职称" prop="rankLevel">
                                    <el-select style="width: 100%;" v-model="topicForm.rankLevel"
                                               placeholder="请选择技术职称">
                                        <el-option v-for="item in rankList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="联系方式" prop="contactInfo">
                                    <el-input v-model="topicForm.contactInfo" placeholder="请输入联系方式"  />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div class="topic-title-container">
                            <div class="topic-title-container1">
                                <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#0d55a4" p-id="12410"></path></svg>
                            </div>
                            <div class="topic-title-container2">
                                子课题规划
                            </div>
                        </div>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="子课题名称" prop="topicName">
                                    <el-input v-model="topicForm.topicName" placeholder="请输入子课题名称"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="课题报名" prop="applyFormTime">
                                    <el-col :span="11" class="date_picker">
                                        <el-date-picker format="YYYY-MM-DD HH:mm"
                                                        @change="startApplyDateConfirm"
                                                        style="width: 100%;" v-model="topicForm.applyBeginTime"
                                                        type="datetime" placeholder="开始时间"
                                                        value-format="x" />
                                    </el-col>
                                    <el-col :span="2" class="text-center">
                                        <span class="text-gray-500">至</span>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-date-picker format="YYYY-MM-DD HH:mm" class="date_picker"
                                                        @change="endApplyDateConfirm"
                                                        style="width: 100%;"
                                                        v-model="topicForm.applyEndTime"
                                                        type="datetime" placeholder="结束时间"
                                                        value-format="x" />
                                    </el-col>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="开题阶段" prop="ktFormTime">
                                    <el-col :span="11" class="date_picker">
                                        <el-date-picker format="YYYY-MM-DD HH:mm" @change="startKtDateConfirm"
                                                        style="width: 100%;" v-model="topicForm.ktBeginTime" type="datetime" placeholder="开始时间"
                                                        value-format="x" />
                                    </el-col>
                                    <el-col :span="2" class="text-center">
                                        <span class="text-gray-500">至</span>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-date-picker format="YYYY-MM-DD HH:mm" class="date_picker" @change="endKtDateConfirm"
                                                        style="width: 100%;" v-model="topicForm.ktEndTime"
                                                        type="datetime" placeholder="结束时间" value-format="x" />
                                    </el-col>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="中期检查" prop="formTime">
                                    <el-col :span="11" class="date_picker">
                                        <el-date-picker format="YYYY-MM-DD HH:mm" @change="startDateConfirm"
                                                        style="width: 100%;" v-model="topicForm.beginTime" type="datetime" placeholder="开始时间"
                                                        value-format="x" />
                                    </el-col>
                                    <el-col :span="2" class="text-center">
                                        <span class="text-gray-500">至</span>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-date-picker format="YYYY-MM-DD HH:mm" class="date_picker"
                                                        @change="endDateConfirm"
                                                        style="width: 100%;" v-model="topicForm.endTime"
                                                        type="datetime" placeholder="结束时间" value-format="x" />
                                    </el-col>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="结题验收" prop="jtFormTime">
                                    <el-col :span="11" class="date_picker">
                                        <el-date-picker format="YYYY-MM-DD HH:mm" @change="startJtDateConfirm"
                                                        style="width: 100%;" v-model="topicForm.jtBeginTime" type="datetime" placeholder="开始时间"
                                                        value-format="x" />
                                    </el-col>
                                    <el-col :span="2" class="text-center">
                                        <span class="text-gray-500">至</span>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-date-picker format="YYYY-MM-DD HH:mm" class="date_picker" @change="endJtDateConfirm"
                                                        style="width: 100%;" v-model="topicForm.jtEndTime"
                                                        type="datetime" placeholder="结束时间" value-format="x" />
                                    </el-col>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="课题介绍" prop="recommend">
                                    <el-input type="textarea" maxlength="1000" v-model="topicForm.recommend" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="研究目的" prop="studyAim">
                                    <el-input type="textarea" maxlength="1000" v-model="topicForm.studyAim" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="研究方法" prop="studyMethod">
                                    <el-input type="textarea" maxlength="1000" v-model="topicForm.studyMethod" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="其他说明" prop="remarks">
                                    <el-input type="textarea" maxlength="1000" v-model="topicForm.remarks" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div class="topic-title-container">
                            <div class="topic-title-container1">
                                <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#0d55a4" p-id="12410"></path></svg>
                            </div>
                            <div class="topic-title-container2">
                                附件说明
                            </div>
                        </div>
                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                <span style="color: red">*</span>最高学历证书上传
                            </div>
                            <div>
                                <el-upload class="upload-demo"
                                           v-model:file-list="xlFileList"
                                           :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                           :headers="{ token }"
                                           :limit="1"
                                           :on-remove="handleFileRemove"
                                           :data="{ topicStatus: 1, topicFileType: 1}"
                                           accept=".pdf,.jpg,.png,"
                                           :before-upload="beforeXlUpload">
                                    <div style="display: flex">
                                        <div class="upload-btn-container">
                                            <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                            <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                        </div>
                                        <div class="upload-btn-tip">
                                            支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                        </div>
                                    </div>

                                </el-upload>
                            </div>
                        </div>

                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                <span style="color: red">*</span>职称证书上传
                            </div>
                            <div>
                                <el-upload class="upload-demo"
                                           v-model:file-list="zcFileList"
                                           :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                           :headers="{ token }"
                                           :limit="1"
                                           :on-remove="handleFileRemove"
                                           :data="{ topicStatus: 1, topicFileType: 2}"
                                           accept=".pdf,.jpg,.png,"
                                           :before-upload="beforeZcUpload">
                                    <div style="display: flex">
                                        <div class="upload-btn-container">
                                            <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                            <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                        </div>
                                        <div class="upload-btn-tip">
                                            支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                        </div>
                                    </div>

                                </el-upload>
                            </div>
                        </div>

                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                参与相关课题证明材料
                            </div>
                            <div>
                                <el-upload class="upload-demo"
                                           v-model:file-list="clFileList"
                                           :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                           :headers="{ token }"
                                           :on-remove="handleFileRemove"
                                           :data="{ topicStatus: 1, topicFileType: 3}"
                                           accept=".pdf,.doc,.docx,"
                                           :before-upload="beforeClUpload">
                                    <div style="display: flex">
                                        <div class="upload-btn-container">
                                            <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                            <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                        </div>
                                        <div class="upload-btn-tip">
                                            支持格式：pdf&nbsp;word &nbsp;&nbsp; 大小限制：10M
                                        </div>
                                    </div>

                                </el-upload>
                            </div>
                        </div>

                    </el-form>
                    <div class="apply-btn-container">
                        <div class="apply-btn" @click="submitTopic">
                            确定
                        </div>
                        <div class="apply-btn-back" @click="backViewInfo">
                            返回
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--查看申报资料-->
        <div class="topic-detail" v-show="showMode==='viewApply'">
            <div class="topic-sign-container">
                <div class="topic-sign-title">子课题申报</div>
                <div class="topic-sign-name">
                    {{info.topicName}}
                </div>
                <div class="topic-sign-form">
                    <el-form ref="topicForm" :model="topicForm"
                             :rules="topicFormRules" label-width="100px">
                        <div class="topic-title-container">
                            <div class="topic-title-container1">
                                <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#0d55a4" p-id="12410"></path></svg>
                            </div>
                            <div class="topic-title-container2">
                                基本信息
                            </div>
                        </div>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="教师姓名" prop="trueName">
                                    <el-input disabled v-model="topicForm.trueName" placeholder="请输入教师姓名"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item label="所属学校" prop="trueName">
                                    <el-input disabled v-model="topicForm.orgName" placeholder="请输入所属学校"  />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="任教学段" prop="periodKey">
                                    <el-select disabled @change="changePeriod" style="width: 100%;" v-model="topicForm.periodKey"
                                               placeholder="请选择任教学段">
                                        <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item  label="任教学科" prop="subjectKey">
                                    <el-select disabled style="width: 100%;" v-model="topicForm.subjectKey"
                                               placeholder="请选择任教学科">
                                        <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="最高学历" prop="qualificationKey">
                                    <el-select disabled style="width: 100%;" v-model="topicForm.qualificationKey"
                                               placeholder="请选择最高学历">
                                        <el-option v-for="item in qualificationList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item label="技术职称" prop="rankLevel">
                                    <el-select disabled style="width: 100%;" v-model="topicForm.rankLevel"
                                               placeholder="请选择技术职称">
                                        <el-option v-for="item in rankList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="联系方式" prop="contactInfo">
                                    <el-input disabled v-model="topicForm.contactInfo" placeholder="请输入联系方式"  />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div class="topic-title-container">
                            <div class="topic-title-container1">
                                <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#0d55a4" p-id="12410"></path></svg>
                            </div>
                            <div class="topic-title-container2">
                                子课题规划
                            </div>
                        </div>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="子课题名称" prop="topicName">
                                    <el-input disabled v-model="topicForm.topicName" placeholder="请输入子课题名称"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="课题报名" prop="applyFormTime">
                                    <el-col :span="11" class="date_picker">
                                        <el-date-picker disabled format="YYYY-MM-DD HH:mm"
                                                        @change="startApplyDateConfirm"
                                                        style="width: 100%;" v-model="topicForm.applyBeginTime"
                                                        type="datetime" placeholder="开始时间"
                                                        value-format="x" />
                                    </el-col>
                                    <el-col :span="2" class="text-center">
                                        <span class="text-gray-500">至</span>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-date-picker disabled format="YYYY-MM-DD HH:mm" class="date_picker"
                                                        @change="endApplyDateConfirm"
                                                        style="width: 100%;"
                                                        v-model="topicForm.applyEndTime"
                                                        type="datetime" placeholder="结束时间"
                                                        value-format="x" />
                                    </el-col>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="开题阶段" prop="ktFormTime">
                                    <el-col :span="11" class="date_picker">
                                        <el-date-picker disabled format="YYYY-MM-DD HH:mm" @change="startKtDateConfirm"
                                                        style="width: 100%;" v-model="topicForm.ktBeginTime" type="datetime" placeholder="开始时间"
                                                        value-format="x" />
                                    </el-col>
                                    <el-col :span="2" class="text-center">
                                        <span class="text-gray-500">至</span>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-date-picker disabled format="YYYY-MM-DD HH:mm" class="date_picker" @change="endKtDateConfirm"
                                                        style="width: 100%;" v-model="topicForm.ktEndTime"
                                                        type="datetime" placeholder="结束时间" value-format="x" />
                                    </el-col>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="中期检查" prop="formTime">
                                    <el-col :span="11" class="date_picker">
                                        <el-date-picker disabled  format="YYYY-MM-DD HH:mm" @change="startDateConfirm"
                                                        style="width: 100%;" v-model="topicForm.beginTime" type="datetime" placeholder="开始时间"
                                                        value-format="x" />
                                    </el-col>
                                    <el-col :span="2" class="text-center">
                                        <span class="text-gray-500">至</span>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-date-picker disabled format="YYYY-MM-DD HH:mm" class="date_picker"
                                                        @change="endDateConfirm"
                                                        style="width: 100%;" v-model="topicForm.endTime"
                                                        type="datetime" placeholder="结束时间" value-format="x" />
                                    </el-col>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="结题验收" prop="jtFormTime">
                                    <el-col :span="11" class="date_picker">
                                        <el-date-picker disabled format="YYYY-MM-DD HH:mm" @change="startJtDateConfirm"
                                                        style="width: 100%;" v-model="topicForm.jtBeginTime" type="datetime" placeholder="开始时间"
                                                        value-format="x" />
                                    </el-col>
                                    <el-col :span="2" class="text-center">
                                        <span class="text-gray-500">至</span>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-date-picker disabled format="YYYY-MM-DD HH:mm" class="date_picker" @change="endJtDateConfirm"
                                                        style="width: 100%;" v-model="topicForm.jtEndTime"
                                                        type="datetime" placeholder="结束时间" value-format="x" />
                                    </el-col>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <!--课题介绍-->
                        <div class="topic-title-container">
                            <div class="topic-title-container1">
                                <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#0d55a4" p-id="12410"></path></svg>
                            </div>
                            <div class="topic-title-container2">
                                课题介绍
                            </div>
                        </div>
                        <div class="topic-content-container">
                            {{topicForm.recommend}}
                        </div>
                        <div class="topic-title-container">
                            <div class="topic-title-container1">
                            </div>
                            <div class="topic-title-container2">
                                研究目的
                            </div>
                        </div>
                        <div class="topic-content-container">
                            {{topicForm.studyAim}}
                        </div>

                        <div class="topic-title-container" >
                            <div class="topic-title-container1">
                            </div>
                            <div class="topic-title-container2">
                                研究方法
                            </div>
                        </div>
                        <div class="topic-content-container">
                            {{topicForm.studyMethod}}
                        </div>

                        <div class="topic-title-container">
                            <div class="topic-title-container1">
                                <svg t="1746002797480" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16363" width="24" height="24"><path d="M512 1024a512 512 0 1 1 512-512 512 512 0 0 1-512 512z m0-819.2a51.2 51.2 0 1 0 51.2 51.2 51.2 51.2 0 0 0-51.2-51.2z m51.2 256a51.2 51.2 0 0 0-102.4 0v307.2a51.2 51.2 0 0 0 102.4 0V460.8z" fill="#0d55a4" p-id="16364"></path></svg>
                            </div>
                            <div class="topic-title-container2">
                                其他说明
                            </div>
                        </div>
                        <div class="topic-content-container">
                            {{topicForm.remarks}}
                        </div>

                        <div class="topic-title-container">
                            <div class="topic-title-container1">
                                <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#0d55a4" p-id="12410"></path></svg>
                            </div>
                            <div class="topic-title-container2">
                                附件说明
                            </div>
                        </div>
                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                <span style="color: red">*</span>最高学历证书上传
                            </div>
                            <div class="file-list">
                                <div class="file-item" v-for="item in topicForm.xlFileList" :key="item">
                                    <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                    <div class="file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                <span style="color: red">*</span>职称证书上传
                            </div>
                            <div class="file-list">
                                <div class="file-item" v-for="item in topicForm.zcFileList" :key="item">
                                    <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                    <div class="file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                参与相关课题证明材料
                            </div>
                            <div class="file-list">
                                <div class="file-item" v-for="item in topicForm.clFileList" :key="item">
                                    <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                    <div class="file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                    </div>
                                </div>
                            </div>
                            <div class="div-100" v-if="topicForm.clFileList&&topicForm.clFileList.length===0">
                                <dataEmpty title="暂无相关文件" />
                            </div>
                        </div>

                    </el-form>
                    <div class="apply-btn-container">
                        <div class="apply-btn" v-if="isApply===0||(isApply===1&&this.topicForm.isCheck!==3)" @click="submitTopic">确定申报</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-mode" v-if="showMode==='topic'">
             <topic-info :info-id="this.topicId" @change-mode="changeModelTopic"/>
        </div>
        <!--成功-->
        <div class="topic-detail" v-if="showMode==='success'">
            <div class="success-container">
                <div class="success-content-container">
                    <div class="success-icon">
<!--                        <img class="img-100" alt="" src="../../assets/success.png">-->
                        <svg t="1748229463840" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3548"><path d="M512 64C265 64 64 265 64 512s201 448 448 448 448-201 448-448S759 64 512 64z m-67 627.4l-0.2-0.2-0.2 0.2-179.2-179.2 45.2-45.2 134.2 134.1 268.6-268.5 45.2 45.2L445 691.4z" fill="#0d55a4" p-id="3549"></path></svg>
                    </div>
                    <div class="success-title">子课题申报完成静待审核</div>
                    <div class="success-item-container">
                        <div class="success-item-title">课题名称：</div>
                        <div class="success-item-content">{{info.topicName}}</div>
                    </div>
                    <div class="success-item-container">
                        <div class="success-item-title">子课题名称：</div>
                        <div class="success-item-content">{{topicForm.topicName}}</div>
                    </div>
                    <div class="success-item-container">
                        <div class="success-item-title">申报时间：</div>
                        <div class="success-item-content">{{ timestampToTime(applyTime)}}</div>
                    </div>
                    <div class="success-btn" @click="successConfirm">确认</div>
                </div>
            </div>
        </div>

        <!--失败-->
        <!--参加子课题-->
        <el-dialog title="子课题列表" v-model="isShowSonTopic" width="640px" :show-close="true">
            <div class="news-item" v-for="item in topicList" :key="item">
                <div class="news-title">
                    <div class="news-title-name">{{item.topicName}}</div>
                    <div class="news-title-time">所属组织：{{item.orgName}}</div>
                    <div class="news-title-time">课题负责人：{{item.leaderNames}}</div>
                    <div class="news-title-time">学段学科：{{item.periodName}}、{{item.subjectName}}</div>
                    <div class="news-title-time">申报时间：{{ timestampToTime(item.applyBeginTime) }}至{{ timestampToTime(item.applyEndTime) }}</div>
                </div>
                <div class="topic-info-box" @click="joinTopic(item.topicId)">
                    <div class="topic-status">
                        <!--                        <img src="../../assets/topic.png" alt>-->
                    </div>
                    <div class="topic-img">
                        <img src="../../assets/topic_bg.png" alt>
                    </div>
                    <div class="topic-level">
                        参加子课题
                    </div>
                </div>
            </div>
            <div class="div-100" v-if="topicList&&topicList.length===0">
                <dataEmpty title="暂无课题" />
            </div>
        </el-dialog>
        <!--参加子课题-->
        <el-dialog title="驳回原因" v-model="isShowReason" width="400px">
            <el-row>
                <el-input disabled type="textarea" rows="6" v-model="reason"/>
            </el-row>

        </el-dialog>
    </div>
</template>

<script>

import {timestampDate2, timestampToTime} from "@/utils/date";
import {downloadFile} from "@/api/adminservice/public";
import { serviceUrl } from "@/utils/global"
import {infoTopic,releaseTopicFile} from "@/api/admin/topic"
import {queryDict} from "@/api/admin/public";
import {leadCreate} from "@/api/admin/lead"
import { deleteTopicFile} from "@/api/admin/topicSign"
import pieEcharts from "@/components/echart/pieEcharts.vue";
import barEcharts from "@/components/echart/barEcharts.vue";
import dataEmpty from "@/components/dataEmpty.vue";
import topicInfo from "@/components/teachResearch/topicInfo.vue";
import pageTag from "@/components/Pagination/page.vue";
import childTopicPieEcharts from "@/components/echart/childTopicPieEcharts";

export default {
    name: "hostTopicInfo",
    components: {pageTag, topicInfo, dataEmpty, barEcharts, pieEcharts,childTopicPieEcharts},
    props:{
        infoId:{
            type: String,
            default:null,
        },
    },
    watch:{
        infoId(newValue,oldValue){
            this.queryInfo()
        },
    },
    data() {
        return {
            serviceUrl,
            loading: false,
            detailMode:"view",
            applyMode:"apply",
            topicMode:"topic",
            successMode:"success",
            failMode:"fail",
            passMode:"pass",
            viewApplyMode:"viewApply", //查看申报资料
            token: this.$storage.get("token"),
            showMode:'view',
            // showMode:'success',
            timestampToTime,
            timestampDate2,
            info:{},
            releaseInfo:{},
            userId:"",
            currentTime:Date.now(),
            applyTime:Date.now(),
            //子课题申报
            isApply:0, //是否申报过子课题
            periodList: [],
            subjectList: [],
            qualificationList:[],
            rankList:[],
            xlFileList:[],//学历
            zcFileList:[],//职称证书
            clFileList:[],//参与相关课题证明材料
            topicForm:{
                parentTopicId:"",// 关联主课题
                qualificationKey:"",
                rankLevel:"",
                contactInfo:"",
                trueName:"",
                orgId:"",
                orgName:"",
                periodKey:"",
                subjectKey:"",
                topicName:"",
                applyBeginTime: '',
                applyEndTime: '',
                beginTime: '',
                endTime: '',
                ktBeginTime: '',
                ktEndTime: '',
                jtBeginTime: '',
                jtEndTime: '',
                recommend: '',
                studyAim: '',
                studyMethod: '',
                remarks: '',
                fileUrls:"",
            },
            topicFormRules: {
                trueName: [{ required: true, message: "请输入教师姓名", trigger: "blur" },],
                orgName: [{ required: true, message: "请输入所属学校", trigger: "blur" },],
                periodKey: [{ required: true, message: "请选择任教学段", trigger: "change" },],
                subjectKey: [{ required: true, message: "请选择任教学科", trigger: "change" },],
                qualificationKey: [{ required: true, message: "请选择最高学历", trigger: "change" },],
                rankLevel: [{ required: true, message: "请选择技术职称", trigger: "change" },],
                topicName: [{ required: true, message: "请输入子课题名称", trigger: "blur" },],
                contactInfo: [{ required: true, message: "请输入联系方式", trigger: "blur" },],
                formTime: [
                    { required: true, validator: this.checkValidator }
                ],
                applyFormTime: [
                    { required: true, validator: this.checkApplyValidator }
                ],
                ktFormTime: [
                    { required: true, validator: this.checkKtValidator }
                ],
                jtFormTime: [
                    { required: true, validator: this.checkJtValidator }
                ],
            },
            isShowSonTopic:false,
            allTopicList:[], //子课题列表
            topicList:[], //子课题列表
            topicId:"",
            isShowReason:false,
            reason:"", //驳回原因
            queryParams:{
                status:"",
                isApply:""
,           },
            statusList:[
                { name: '报名阶段', value: 1 },
                { name: '中期检查', value: 2 },
                { name: '开题论证', value: 3 },
                { name: '结题验收', value: 4 },
            ],
            joinList:[
                { name: '未参与', value: "0" },
                { name: '已参与', value: "1" },
            ]
        };
    },
    created() {
        this.userId = JSON.parse(this.$storage.get("userInfo")).userId
        this.topicForm.trueName = JSON.parse(this.$storage.get("userInfo")).trueName
        this.topicForm.orgId = JSON.parse(this.$storage.get("userInfo")).orgId
        this.topicForm.orgName = JSON.parse(this.$storage.get("userInfo")).orgName
        this.getQueryDict();
    },
    mounted() {
        this.queryInfo()
    },
    computed: {},
    methods: {
        getQueryDict() {
            /*档案学段学科*/
            queryDict({ code: 'archive_xd_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            /*最高学历*/
            queryDict({ code: 'qualification' }).then(res => {
                this.qualificationList = res.data.data;
            })
            /*技术职称*/
            queryDict({ code: 'technical_title' }).then(res => {
                this.rankList = res.data.data;
            })
        },
        changePeriod() {
            this.topicForm.subjectKey = '';
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.topicForm.periodKey === j.dictKey) {
                    this.subjectList = j.childrenList;
                }
            })
        },
        queryInfo(){
            infoTopic({ topicId: this.infoId }).then(res => {
                if (res.data.code===1){
                    this.showMode = this.detailMode
                    this.info = res.data.data
                    this.isApply = this.info.isApply;
                    this.topicList = this.info.sonTopicList
                    this.allTopicList = this.info.sonTopicList
                    // 已发布文件
                    if (this.info.isRelease===1){
                        this.getTopicReleaseFile()
                    }
                    if (this.info.isApply===1){
                        this.isApply = 1;
                        this.topicForm = this.info.sonTopic;
                        this.reason = this.topicForm.reason;
                        this.applyTime = this.topicForm.createTime
                        //申报资料
                        this.xlFileList=[]
                        this.topicForm.xlFileList.forEach(e => {
                            this.xlFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.zcFileList  = []
                        this.topicForm.zcFileList.forEach(e => {
                            this.zcFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.clFileList = []
                        this.topicForm.clFileList.forEach(e => {
                            this.clFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    data: e.fileUrl
                                }
                            })
                        })
                        //
                        /*档案学段学科*/
                        queryDict({ code: 'archive_xd_xk' }).then(res => {
                            this.periodList = res.data.data;
                            this.subjectList = [];
                            this.periodList.forEach(j => {
                                if (this.topicForm.periodKey === j.dictKey) {
                                    this.subjectList = j.childrenList;
                                }
                            })
                        })
                    }
                }
            })
        },
        getTopicReleaseFile(){
            releaseTopicFile({ topicId: this.infoId }).then(res => {
                if (res.data.code === 1) {
                    this.releaseInfo = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }

            })
        },
        downloadFile(item){
            downloadFile(item.fileUrl, item.fileName)
        },
        handleFIleStatus(status){
            if (status === 1) {
            }else {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl,page,fileType,fileUrl){
            const list = [];
            if (fileType &&(fileType.toLowerCase()==='png'||fileType.toLowerCase()==='jpg'||fileType.toLowerCase()==='jpeg')){
                list.push(fileUrl);
            }else {
                for (let i = 1; i <=page ; i++) {
                    list.push(baseUrl+'/' + i+'.png');
                }
            }

            return list;
        },
        changeModel(){
            this.$emit('change-mode', this.pageMode);
        },
        changeModelTopic(){
            this.showMode = this.detailMode
        },
        applyTopic(){
            this.showMode = this.applyMode;
        },
        backViewInfo(){
            this.showMode = this.detailMode;
        },
        viewApplyTopic(){
            this.showMode = this.viewApplyMode;
        },
        /*移除文件*/
        handleFileRemove(file, uploadFiles) {
            if (file.response.data) {
                deleteTopicFile({ fileUrl: file.response.data }).then(res => {})
            }
        },
        /*学历文件上传*/
        beforeXlUpload(rawFile) {
            if (!(rawFile.type === 'application/pdf' ||
              rawFile.type === 'image/png' ||
              rawFile.type === 'image/jpg'||
              rawFile.type === 'image/jpeg')) {
                this.$message.error('暂不支持此类型文件')
                return false
            } else if (rawFile.size / 1024 / 1024 > 5) {
                this.$message.error('文件大小不得超过5M')
                return false
            }
            return true
        },
        /*职称证书文件上传*/
        beforeZcUpload(rawFile) {
            if (!(rawFile.type === 'application/pdf' ||
              rawFile.type === 'image/png' ||
              rawFile.type === 'image/jpg'||
              rawFile.type === 'image/jpeg')) {
                this.$message.error('暂不支持此类型文件')
                return false
            } else if (rawFile.size / 1024 / 1024 > 5) {
                this.$message.error('文件大小不得超过5M')
                return false
            }
            return true
        },
        /*证明材料文件上传*/
        beforeClUpload(rawFile) {
            if (!(rawFile.type === 'application/pdf' ||
              rawFile.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
              rawFile.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
              rawFile.type == 'application/msword')) {
                this.$message.error('暂不支持此类型文件')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('文件大小不得超过10M')
                return false
            }
            return true
        },
        /*提交子课题申报*/
        submitTopic(){
            this.topicForm.parentTopicId = this.info.topicId
            const fileList = [];
            if (this.xlFileList.length === 0) {
                this.$message.error("请上传学历文件")
                return
            }
            this.xlFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            if (this.zcFileList.length === 0) {
                this.$message.error("请上传职称证书")
                return;
            }
            this.zcFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.clFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })

            this.$refs["topicForm"].validate(valid => {
                if (valid) {
                    const obj = JSON.parse(JSON.stringify(this.topicForm));
                    obj.fileUrls = fileList.toString();
                    leadCreate(obj).then(res => {
                        if (res.data.code === 1) {
                            // this.$message.success("申报成功");
                            this.showMode = this.successMode
                            // this.queryInfo()
                        }else {
                            this.$message.error("申报失败")
                        }
                    })
                }
            })
        },
        startDateConfirm(e) {
            // if (e >= this.topicForm.endTime) {
            //     this.topicForm.endTime = '';
            // }
        },
        startApplyDateConfirm(e) {
            // if (e >= this.topicForm.applyEndTime) {
            //     this.topicForm.applyEndTime = '';
            // }
        },
        startKtDateConfirm(e) {
            // if (e >= this.topicForm.ktEndTime) {
            //     this.topicForm.ktEndTime = '';
            // }
        },
        startJtDateConfirm(e) {
            // if (e >= this.topicForm.jtEndTime) {
            //     this.topicForm.jtEndTime = '';
            // }
        },
        endDateConfirm(e) {
            // if (e <= this.topicForm.beginTime) {
            //     this.topicForm.beginTime = '';
            // }
        },
        endApplyDateConfirm(e) {
            // if (e <= this.topicForm.applyBeginTime) {
            //     this.topicForm.applyBeginTime = '';
            // }
        },
        endKtDateConfirm(e) {
            // if (e <= this.topicForm.ktBeginTime) {
            //     this.topicForm.ktBeginTime = '';
            // }
        },
        endJtDateConfirm(e) {
            // if (e <= this.topicForm.jtBeginTime) {
            //     this.topicForm.jtBeginTime = '';
            // }
        },
        checkApplyValidator(rule, value, callback) {
            if (this.topicForm.applyBeginTime === '' || !this.topicForm.applyBeginTime) {
                callback(new Error('请选择开始时间'))
            } else if (this.topicForm.applyEndTime === '' || !this.topicForm.applyEndTime) {
                callback(new Error('请选择结束时间'))
            } else if(this.topicForm.applyEndTime<this.topicForm.applyBeginTime){
                this.topicForm.applyEndTime = ''
                callback(new Error('结束时间必须在开始时间之后'))
            }else {
                callback()
            }
        },
        checkKtValidator(rule, value, callback) {
            if (this.topicForm.applyEndTime === '' || !this.topicForm.applyEndTime) {
                callback(new Error('请选择报名结束时间'))
            } else if (this.topicForm.ktBeginTime === '' || !this.topicForm.ktBeginTime) {
                callback(new Error('请选择开始时间'))
            } else if( this.topicForm.ktBeginTime < this.topicForm.applyEndTime){
                callback(new Error('开题开始时间必须大于报名结束时间'))
            }else if (this.topicForm.ktEndTime === '' || !this.topicForm.ktEndTime) {
                callback(new Error('请选择结束时间'))
            } else if (this.topicForm.ktEndTime < this.topicForm.ktBeginTime) {
                this.topicForm.ktEndTime = ''
                callback(new Error('结束时间必须在开始时间之后'))
            } else {
                callback()
            }
        },
        checkValidator(rule, value, callback) {
            if (this.topicForm.ktEndTime === '' || !this.topicForm.ktEndTime) {
                callback(new Error('请选择开题结束时间'))
            } else if (this.topicForm.beginTime === '' || !this.topicForm.beginTime) {
                callback(new Error('请选择开始时间'))
            } else if( this.topicForm.beginTime < this.topicForm.ktEndTime){
                callback(new Error('中期开始时间必须大于开题结束时间'))
            }else if (this.topicForm.endTime === '' || !this.topicForm.endTime) {
                callback(new Error('请选择结束时间'))
            } else if (this.topicForm.endTime < this.topicForm.beginTime) {
                this.topicForm.endTime = ''
                callback(new Error('结束时间必须在开始时间之后'))
            } else {
                callback()
            }
        },
        checkJtValidator(rule, value, callback) {
            if (this.topicForm.endTime === '' || !this.topicForm.endTime) {
                callback(new Error('请选择中期结束时间'))
            } else if (this.topicForm.jtBeginTime === '' || !this.topicForm.jtBeginTime) {
                callback(new Error('请选择开始时间'))
            } else if( this.topicForm.jtBeginTime < this.topicForm.endTime){
                callback(new Error('结题开始时间必须大于中期结束时间'))
            }else if (this.topicForm.jtEndTime === '' || !this.topicForm.jtEndTime) {
                callback(new Error('请选择结束时间'))
            } else if (this.topicForm.jtEndTime < this.topicForm.jtBeginTime) {
                this.topicForm.endTime = ''
                callback(new Error('结束时间必须在开始时间之后'))
            } else {
                callback()
            }
        },
        disabledDate(current) {
            return current && current < Number(new Date()) - 86400000
        },
        enddisabledDate(current) {
            if (this.topicForm.beginTime) {
                return current && current < this.topicForm.beginTime
            } else {
                return current && current < Number(new Date()) - 86400000
            }
        },
        joinSonTopic(){
            const targetElement = document.querySelector('#sonTopic'); // 获取目标元素
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动到目标元素
            }
        },
        joinTopic(topicId){
            this.topicId = topicId;
            this.showMode = this.topicMode;
            this.isShowSonTopic = false;
            this.backTop()
        },
        viewReason(){
            this.isShowReason = true;
        },
        // 回到顶部
        backTop() {
            const targetElement = document.querySelector('#home-top'); // 获取目标元素
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动到目标元素
            }
        },
        filterSonTopic(){
            if (this.queryParams.status&&this.queryParams.isApply){
                this.topicList = this.allTopicList.filter((item) => {
                    return item.status == this.queryParams.status&&item.isApply == this.queryParams.isApply;
                })
            }else {
                if (this.queryParams.status){
                    this.topicList = this.allTopicList.filter((item) => {
                        return item.status == this.queryParams.status;
                    })
                }
                if (this.queryParams.isApply){
                    this.topicList = this.allTopicList.filter((item) => {
                        return item.isApply == this.queryParams.isApply;
                    })
                }
                if (!this.queryParams.status&& !this.queryParams.isApply){
                    this.topicList = this.allTopicList;
                }

            }
        },
        successConfirm(){
            this.queryInfo();
        }
    }
};
</script>
<style scoped>
.course-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    box-sizing: border-box;
}
.topic-detail{
    width: 100%;
    height: auto;
}
.topic-top{
    width: calc(100% - 220px);
    height: 100px;
    background-color: #0d55a4;
    display: flex;
    position: fixed;
    top: 80px;
    left: 210px;
    z-index: 999;
}
.topic-top-left{
    width: calc(100% - 240px);
    height: 100%;
}
.top-left1{
    height: 50px;
    width: 100%;
    color: #fff;
    line-height: 60px;
    text-indent: 30px;
    font-size: 20px;
    font-weight: bold;
}
.top-left2{
    height: 50px;
    width: 100%;
    color: #fff;
    text-indent: 30px;
    font-size: 15px;
    font-weight: bold;
    line-height: 35px;
}
.topic-top-right{
    width: 240px;
    height: 100%;
    padding: 10px 10px 10px 0;
    box-sizing: border-box;
}
.top-right-item{
    width: 100%;
    height: 50%;
    display: flex;
}
.top-right1{
    height: 30px;
    width: 100px;
    line-height: 30px;
    font-size: 14px;
    margin: auto;
    font-weight: bold;
    text-align: center;
    border-radius: 5px;
    cursor: pointer;
}
.top-right2{
    height: 30px;
    width: 100px;
    line-height: 30px;
    font-size: 14px;
    margin: auto;
    font-weight: bold;
    text-align: center;
    border-radius: 5px;
    cursor: pointer;
}
.btn-sbkt{
    color: #4095e5;
    background-color: #fff;
}
.btn-cjkt{
    color: #4095e5;
    background-color: #ffbf6b;
}
.topic-info-container{
    width: 100%;
    height: auto;
    padding-top: 110px;
    display: flex;
}
.topic-info-l-container{
    width: calc(100% - 240px);
    height: auto;
}
.topic-info-l-content{
    width: calc(100% - 10px);
    height: auto;
    background-color: #fff;
    padding: 20px 20px 20px 20px;
    box-sizing: border-box;
}
.topic-time-container{
    width: 100%;
    height: auto;
}
.topic-time-top{
    width: 100%;
    height: 30px;
    display: flex;
}
.topic-time-top1{
    width: 24px;
    height: 30px;
}
.topic-time-top2{
    width: calc(100% - 24px);
    height: 30px;
    font-size: 16px;
    font-weight: bold;
    color: #0d55a4;
    text-indent: 5px;
}
.topic-time-content{
    width: 100%;
    height: 60px;
    display: flex;
}
.time-content-item{
    width: 50%;
    height: 60px;
    display: flex;
}
.time-point{
    width: 40px;
    height: 60px;
}
.point{
    width: 16px;
    height: 16px;
    border-radius: 8px;
    background-color: #0d55a4;
    margin-top: 6px;
}
.time-item{
    width: calc(100% - 40px);
    height: 60px;
}
.time-title1{
    height: 30px;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    line-height: 30px;
}
.time-title2{
    height: 30px;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
}
.topic-title-container{
    width: 100%;
    height: 40px;
    display: flex;
}
.topic-title-container1{
    width: 30px;
    height: 40px;
    box-sizing: border-box;
    padding-top: 8px;
}
.topic-title-container2{
    width: calc(100% - 50px);
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: bold;
    color: #0d55a4;
}
.topic-base-info-container{
    width: 100%;
    height: auto;
    padding-left: 30px;
    box-sizing: border-box;
}
.base-one-container{
    width: 100%;
    height: 30px;
    display: flex;
}
.base-one-info{
    width: 50%;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.base-one-info-80{
    width: 80%;
    height: auto;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.topic-content-container{
    width: 100%;
    height: auto;
    padding-left: 10px;
    box-sizing: border-box;
    text-indent: 40px;
    font-size: 14px;
    color: #767676;
    line-height: 24px;
}
.topic-content-container-img{
    width: 100%;
    height: auto;
    padding-left: 50px;
    box-sizing: border-box;
    font-size: 14px;
    color: #767676;
    line-height: 24px;
}
.file-list{
    width: 100%;
    height: auto;
}
.file-item{
    display: flex;
    height: 30px;
    width: 100%;
    padding-left: 30px;
    padding-right: 50px;
    box-sizing: border-box;
    cursor: pointer;
}
.file-item:hover{
    color: #0d55a4!important;
    font-weight: bold;
}

.file-item-second{
    display: flex;
    height: 30px;
    width: 100%;
    padding-right: 30px;
    box-sizing: border-box;
    cursor: pointer;
}
.file-item-second:hover{
    color: #0d55a4!important;
    font-weight: bold;
}


.file-title{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
}
.file-view{
    width: 30px;
    height: 100%;
}
.file-download{
    width: 30px;
    height: 100%;
}
.file-icon{
    width: 20px;
    height: 20px;
    cursor: pointer;
}
.back-btn-container{
    width: 100%;
    height: 60px;
    background-color: #fff;
    padding-top: 15px;
    box-sizing: border-box;
    margin-top: 10px;
}
.back-btn{
    width: 80px;
    height: 30px;
    line-height: 30px;
    border-radius: 6px;
    background-color: #0d55a4;
    font-size: 14px;
    text-align: center;
    color: #fff;
    margin: auto;
    cursor: pointer;
    font-weight: bold;
}
/*子课题申报*/
.topic-sign-container{
    width: 100%;
    height: auto;
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 10px;
    box-sizing: border-box;
    background-color: #fff;
}
.topic-sign-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: bold;
    color: #0d55a4;
    margin-top: 5px;
    text-align: center;
}
.topic-sign-title-second{
    display: flex;
    width: 100%;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    font-weight: bold;
    color: #000000;
    padding-left: 30px;
    box-sizing: border-box;
}
.topic-sign-name{
    width: 100%;
    height: 30px;
    //line-height: 30px;
    font-size: 15px;
    color: #767676;
    text-align: center;
}
.topic-sign-form{
    width: 100%;
    height: auto;
}
.item-title-tio{
    font-size: 14px;
    color: #767676;
    font-weight: normal!important;
    margin-left: 60px;
}
/deep/ .el-form-item{
    //margin-bottom: 10px!important;
}
/deep/ .el-form-item__label{
    color:#6a6a6a!important;
    font-weight:bold;
    font-size:14px
}
.topic-file-container{
    width: 98%;
    height: auto;
    border: 1px solid #e6e6e6;
    border-radius: 10px;
    padding: 10px 10px 10px 15px;
    box-sizing: border-box;
    margin-bottom: 5px;
    margin-top: 5px;
}

.topic-file-container-second{
    width: calc(100% - 40px);
    height: auto;
    border: 1px solid #e6e6e6;
    border-radius: 10px;
    padding: 10px 10px 10px 15px;
    box-sizing: border-box;
    margin-bottom: 5px;
    margin-top: 5px;
    margin-left: 30px;
}

.topic-file-item-title{
    height: 30px;
    color:#000;
    font-weight:bold;
    font-size:14px
}
.upload-btn-container{
    width: 160px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #0d55a4;
    color: #fff;
    border-radius: 5px;
    display: flex;
}
.upload-btn-tip{
    text-indent: 40px;
    line-height: 40px;
    font-size: 13px;
    font-weight: bold;
    color: #767676;
}
/*.apply-btn-container{
    width: 100%;
    height: 40px;
    padding-top: 10px;
    display: flex;
}
.apply-btn{
    width: 200px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #0d55a4;
    color: #fff;
    border-radius: 5px;
    margin: auto;
    cursor: pointer;
}*/

.apply-btn-container{
    width: 200px;
    height: 40px;
    padding-top: 30px;
    display: flex;
    margin: auto;
}
.apply-btn{
    width: 80px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #0d55a4;
    color: #fff;
    border-radius: 5px;
    margin: auto;
    cursor: pointer;
}
.apply-btn-back{
    width: 80px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #FFFFFF;
    color: #909399;
    border-radius: 5px;
    margin: auto;
    cursor: pointer;
    border: 1px solid #909399;
}
.bg-dsh{
    background-color: #93d2f3;
    color: #fff!important;
}
.bg-ytg{
    background-color: #81b336;
    color: #fff!important;
}
.bg-wtg{
    background-color: #bd3124;
    color: #fff!important;
}
/deep/ .el-dialog__title{
    font-size: 16px;
}
.news-item{
    display: flex;
    width: 100%;
    height: 135px;
    cursor: pointer;
}
.new-cover{
    width: 240px;
    height: 120px;
    img{
        width: 100%;
        height: 100%;
    }
}
.news-title{
    width: 100%;
    height: 120px;
    padding-left: 20px;
    cursor: pointer;
}
.news-title-name{
    width: 100%;
    height: 40px;
    cursor: pointer;
    font-size: 15px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.news-title-name:hover{
    color: #0d55a4!important;
}
.news-title-time{
    width: 100%;
    height: 20px;
    font-size: 14px;
    line-height: 20px;
}
.topic-info-box{
    width: 240px;
    height: 120px;
    position: relative;
    border-radius: 8px;
    border: 1px solid #cecece;
}
.topic-status{
    position: absolute;
    width: 44px;
    height: 36px;
    z-index: 99;
    top: 2px;
    left: 2px;
    img{
        width: 100%;
        height: 100%;
    }
}
.topic-img{
    position: absolute;
    width: 72px;
    height: 72px;
    z-index: 9;
    top: 50px;
    right: 0;
    img{
        width: 100%;
        height: 100%;
    }
}
.topic-level{
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 999;
    font-size: 16px;
    font-weight: bold;
    color: #e87b17;
    text-align: center;
    line-height: 120px;
}
.info-list-container{
    width: 100%;
    height: auto;
    margin: auto;
    margin-top: 10px;
    overflow-x: hidden;
    background-color: #FFFFFF;
}
/*课程*/
.course-list-box{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding-right: 10px;
    //padding-top: 10px;
    align-items: center;
    box-sizing: border-box;
    background-color: #fff;
}
.course-item{
    width: 33.3%!important;
    height: auto;
    padding-left: 10px;
    padding-bottom: 10px;
    box-sizing: border-box;
}
.course-one{
    width: 100%;
    height: 100%;
    padding: 10px;
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
}
.course-info{
    display: flex;
    width: 100%;
    height: 110px;
    padding-top: 5px;
}
.course-cover{
    width: 40%;
    height: 100%;
    box-shadow: var(--el-box-shadow-light);
    img{
        width: 100%;
        height: 100%;
    }
}
.course-title{
    width: 60%;
    height: 100%;
}
.course-name{
    width: 100%;
    font-size: 15px;
    color: #333;
    font-weight: bold;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    height: 45px;
}
.course-time{
    width: 100%;
    font-size: 14px;
    color: #333;
    height: 20px;
    line-height: 20px;
}
.course-subject{
    padding-left: 10px;
    box-sizing: border-box;
    font-size: 14px;
    color: #333333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 25px;
    display: flex;
}
.status-info-cs{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #00a173;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.status-info-bm{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #4095e5;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.status-info-kt{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #ffbf6b;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.status-info-zq{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #bd3124;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.status-info-jt{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #81b337;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.status-info-js{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #54bcbd;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.status-info-ycy{
    width: 55px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #67c23a;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
    margin-left: 10px;
}
.status-info-wcy{
    width: 55px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #909399;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
    margin-left: 10px;
}
.course-commend{
    padding-left: 10px;
    padding-top: 2px;
    box-sizing: border-box;
    color: #333333;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
}
.course-team-user{
    padding-left: 10px;
    padding-top: 2px;
    box-sizing: border-box;
    color: #333333;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
/*子课题统计图*/
.topic-info-r-container{
    width: 240px;
    height: auto;
    background-color: #fff;
}
.topic-data-title{
    width: 100%;
    height: 40px;
    font-size: 16px;
    font-weight: bold;
    line-height: 40px;
    //color: #4f46e4;
    color: #0d55a4;
    text-indent: 10px;
}
/*申报成功*/
.success-container{
    width: 100%;
    height: calc(100vh - 100px);
    overflow-y: hidden;
    background-color: #fff;
}
.success-content-container{
    width: 40%;
    height: 100%;
    margin: auto;
}
.success-title{
    width: 100%;
    height: 80px;
    line-height: 40px;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    color: #000;
}
.success-icon{
    width: 64px;
    height: 124px;
    padding-top: 60px;
    box-sizing: border-box;
    margin: auto;
}
.success-item-container{
    width: 100%;
    height: auto;
    display: flex;
    padding-bottom: 5px;
}
.success-item-title{
    width: 140px;
    font-size: 15px;
    color: #767676;
    text-align: right;
}
.success-item-content{
    width: calc(100% - 140px);
    height: auto;
    line-height: 20px;
    font-size: 15px;
    color: #333;
    text-align: left;
    padding-left: 15px;
    box-sizing: border-box;
}
.success-btn{
    width: 100px;
    height: 36px;
    line-height: 36px;
    margin: auto;
    margin-top: 50px;
    text-align: center;
    border-radius: 6px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    background-color: #0d55a4;
    cursor: pointer;
}
</style>

